import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '../../../../assets/images/close.svg';
import { ReactComponent as ImportIcon } from '../../../../assets/images/import.svg';
import { ReactComponent as LinkedinIcon } from '../../../../assets/images/linkedinicon.svg';
import Button from '../../../../components/shared/Button/Button';
import urls from '../../../../routing/urls';

import styles from './LinkedinPopup.module.scss';

const LinkedinPopup = ({ onClose }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headingCont}>
          <LinkedinIcon className={styles.linkedinTop} />
          <p className={`${styles.text} ${styles.textBold}`}>{t('strengthen.importFromLinkedin')}</p>
        </div>
        <div onClick={onClose} role="presentation" className={styles.closeBtn}>
          <CloseIcon />
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.infoCont}>
        <LinkedinIcon className={styles.linkedinBottom} />
        <p className={styles.text}>{t('strengthen.superchargeAccount')}</p>
        <Button className={styles.btn} onClick={() => navigate(urls.linkedinProfileImport)}>
          <ImportIcon />
          {t('strengthen.import')}
        </Button>
      </div>
    </div>
  );
};

export default LinkedinPopup;
